export default __webpack_public_path__ + "static/media/breath.394c15de.svg";